export const ACTION_TYPES = {
    SET_WALLET: 'SET_WALLET',
    SET_CHAIN_ID: 'SET_CHAIN_ID',
    SET_CONNECT_WALLET: 'SET_CONNECT_WALLET',
    DELETE: 'DELETE',
};
